import { createContext } from "react";
import { IToasterProps } from "../types";

export interface ITaxContext {
  getData: (page?: number, importedTax?: []) => void;
  setToaster: (toaster: IToasterProps) => void;
}

export const TaxContext = createContext<ITaxContext>({} as ITaxContext);
